// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../CrossD.Portal.Vue/ClientApp/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../CrossD.Portal.Vue/ClientApp/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--cd-gradient-color:linear-gradient(180deg,#2478d8,#0189b8);--cd-c-brand:#2478d8;--cd-w-menu:260px}.content-wrapper{position:relative;left:var(--cd-w-menu);width:calc(100% - var(--cd-w-menu));transition:all .5s}@media (max-width:576px){.content-wrapper{--cd-w-menu:40px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
